export default {
  CHANNELS: {
    CC: 'contact-center',
    GIL: 'gil',
    OPS: 'ops',
    WEB: 'web'
  }
};